var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"theme-toggle",attrs:{"type":"button","title":_vm.title},on:{"click":_vm.toggle}},[_c('span',[_vm._v(_vm._s(_vm.isDark ? '🌙' : '☀️'))]),_c('span',[_vm._v(_vm._s(_vm.isDark ? '夜间' : '日间'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }